enum Platform {
    WEB,
    TEAMS,
    SLACK,
    WEBEX,
    MOBILE
}

export default Platform
